'use client';
import { useFormContext, useController } from 'react-hook-form';
export const useRadioController = (props, callback) => {
    const { control } = useFormContext();
    const { field, fieldState, ...rest } = useController({ control, ...props });
    const isError = !!fieldState.error;
    const errorNote = fieldState.error?.message;
    const radioChange = (e) => {
        field.onChange(e);
        callback?.(e);
    };
    const getRadioField = (id = '', value = '') => {
        const checked = field.value === value;
        return { ...field, checked, onBlRadioChange: radioChange, id, value };
    };
    return {
        field,
        fieldState,
        getRadioField,
        radioFieldset: { errorNote, isError },
        ...rest
    };
};
